export default __webpack_public_path__ + "static/media/black.79b0a771.svg";